import { useField } from 'formik';

import FormField from '../FormField';
import Label from '../Label';
import Select from '../Select';
import ErrorText from '../ErrorText';

function SelectField(props) {
  const { label, ...selectProps } = props;
  const [field, meta] = useField(props);
  const hasError = Boolean(meta.touched && meta.error);

  return (
    <FormField>
      {label && (
        <Label htmlFor={selectProps.id || selectProps.name}>{label}</Label>
      )}
      <Select {...field} {...selectProps} error={hasError} />
      {hasError ? <ErrorText>{meta.error}</ErrorText> : null}
    </FormField>
  );
}

export default SelectField;
